import { getPublicApi } from './components/MySubscriptions/PublicApi/viewerPublicApi';
import { InitAppForPageFn, IHttpClient } from '@wix/yoshi-flow-editor';

export interface ViewerScriptContext {
  httpClient?: IHttpClient | undefined;
  panoramaClient?: any | undefined;
}
const mySubscriptionsViewerContext: ViewerScriptContext = {};

export const initAppForPage: InitAppForPageFn = async (
  _initParams,
  _platformApis,
  _wixCodeApi,
  _platformServicesApis,
  flowAPI,
) => {
  mySubscriptionsViewerContext.httpClient = flowAPI.httpClient;
  mySubscriptionsViewerContext.panoramaClient = flowAPI.panoramaClient;
  return {};
};

// This exponses public APIs to other viewer apps, **don't delete this**!
export const exports = getPublicApi(mySubscriptionsViewerContext);
